import { SendApplicationRequest } from '@interfaces/models';
import { UseFormReturn, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { sendApplication } from '@api/help';
import { toast } from '@ui/components';
import { TFunction } from 'i18next';
import * as z from 'zod';

export const sendApplicationFormSchema = (t: TFunction) =>
  z.object({
    topicId: z.string().trim().min(1, t('FORMS.REQUIRED')),
    content: z
      .string()
      .trim()
      .min(5, t('FORMS.MIN_CHARACTERS', { limit: 5 }))
      .max(500, t('FORMS.MAX_CHARACTERS', { limit: 500 })),
  });

export type SendApplicationForm = z.infer<ReturnType<typeof sendApplicationFormSchema>>;

export const useSendApplicationModal = ({
  onSuccess,
}: {
  onSuccess: () => void;
}): {
  onSubmit: (payload: SendApplicationRequest) => void;
  form: UseFormReturn<SendApplicationForm>;
  isLoading: boolean;
} => {
  const { t } = useTranslation();

  const form = useForm<SendApplicationForm>({
    defaultValues: { topicId: '', content: '' },
    resolver: zodResolver(sendApplicationFormSchema(t)),
    mode: 'onBlur',
  });

  const onSubmit = (data: SendApplicationRequest): void => {
    sendApplicationMutation.mutate(data);
  };

  const sendApplicationMutation = useMutation({
    mutationFn: sendApplication,
    onSuccess: () => {
      toast.success(t('HELP.SEND_APPLICATION_SUCCESS'));
      onSuccess();
    },
  });

  return { form, onSubmit, isLoading: sendApplicationMutation.isPending };
};
